import { useState, useEffect } from 'react';
import { getAdminSettings, updateAdminSettings } from '../services/api';

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getAdminSettings().then(setSettings).catch(() => setError('Failed to load settings'));
  }, []);

  const toggle = async (key) => {
    const updated = { ...settings, [key]: !settings[key] };
    setSettings(updated); // optimistic
    setSaving(true);
    setError('');
    try {
      await updateAdminSettings({ [key]: updated[key] });
    } catch (err) {
      setSettings(settings); // revert on failure
      setError(err.response?.data?.error || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return <div style={{ padding: '2rem' }}>{error || 'Loading…'}</div>;

  return (
    <div style={{ maxWidth: 560 }}>
      <h2>Admin settings</h2>
      <div className="card" style={{ marginTop: '1rem' }}>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: '1.25rem', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={settings.publicRegistrationEnabled}
            onChange={() => toggle('publicRegistrationEnabled')}
            disabled={saving}
            style={{ marginTop: 3 }}
          />
          <span>
            <strong>Allow public sign-up</strong>
            <div className="muted" style={{ fontSize: 13 }}>
              When off, the sign-up page is hidden and the registration endpoint itself
              returns "not found" — indistinguishable from not existing at all.
            </div>
          </span>
        </label>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={settings.require2FAForAll}
            onChange={() => toggle('require2FAForAll')}
            disabled={saving}
            style={{ marginTop: 3 }}
          />
          <span>
            <strong>Require two-factor authentication for all users</strong>
            <div className="muted" style={{ fontSize: 13 }}>
              Anyone without 2FA set up will be walked through setup on their next login
              before they can do anything else.
            </div>
          </span>
        </label>
        {error && <p className="error" style={{ marginTop: '1rem' }}>{error}</p>}
      </div>
    </div>
  );
}
